export const GET_DISEASES_HISTORY_DATA = "get_disease_history_data";
export const REQ_DISEASES_HISTORY_DATA = "req_disease_history_data";
export const SET_DISEASES_HISTORY_DATA = "set_disease_history_data";
export const GET_DISEASE_DISEASES_LIST = "get_disease_disease_list";
